import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedirectLinkComponent } from './redirect-link/redirect-link.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [RedirectLinkComponent],
  exports: [RedirectLinkComponent],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class RedirectLinkModule { }
